import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { DecodeResponse } from "../../Models/Response/Redirection/redirection";
import { setDecryptedCredential } from "../../Services/LocalStorageServices";
import { decode } from "../../Services/RedirectionServices/Redirection";
import { QueryParams, Routes } from "../../Utils/Constants/routes";

const Redirection: React.FC = () => {
  const history = useHistory();
  useEffect(() => {
    const queryParam = new URLSearchParams(history.location.search);

    const fi = queryParam.get("fi")?.replace(/\s/g, "+");
    const reqdate = queryParam.get("reqdate");
    const ecreq = queryParam.get("ecreq");

    console.log("FI: " + fi?.toString());

    if (!!fi && !!reqdate && !!ecreq) {
      decode({ fi, ecreq, reqdate })
        .then((res) => res.data)
        .then((res: DecodeResponse) => {
          setDecryptedCredential(res);
          console.log("Redirection Response: ", res);

          const redirectPath = `/consent/PENDING/${res.srcref}`;
          localStorage.setItem("redirectAfterAccountLink", redirectPath);

          const identifiers: any[] = [];
          if (res.pan != null && res.pan.trim() !== "") {
            identifiers.push({type: "PAN", value: res.pan, categoryType: "WEAK"});
          }
          if (res.dob != null && res.dob.trim() !== "") {
            const dob = new Date(res.dob);
            const formattedDob = `${String(dob.getDate()).padStart(2, "0")}/${String(
              dob.getMonth() + 1
            ).padStart(2, "0")}/${String(dob.getFullYear()).slice(-2)}`;

            identifiers.push({type: "DOB", value: formattedDob, categoryType: "WEAK"});
          }
          //set pan and dob in local storage while redirection
          localStorage.setItem("additionalIdentifier", JSON.stringify(identifiers));

          if (res.isUserPresent) {
            history.push({
              pathname: Routes.login,
              search: `?${QueryParams.redirect}=/consent/PENDING/${res.srcref}`,
              state: { phoneNumber: res.phoneNumber, fiuID: res.fiuId},
            });
          } else {
            history.push({
              pathname: Routes.signup,
              search: `?${QueryParams.redirect}=/consent/PENDING/${res.srcref}`,
              state: { phoneNumber: res.phoneNumber,  email: res.email ||"",fiuID: res.fiuId, isVuaIdDisabled: true },
            });
          }
        })
        .catch((res: any) => {
          if (!!res.redirectōUrl) {
            window.location.replace(res.redirectUrl);
          }
        });
    }
  }, [history]);

  return <div>Loading...</div>;
};

export default Redirection;
